
import Injection = EECore.Injection;
import Request from "../entities/documentCentre/querySuggestRequest";
import Response, { Completion } from "../entities/documentCentre/querySuggestResponse";
import QuerySuggestion from "../entities/documentCentre/querySuggestion";

class CompletionParseRule {
  match: RegExp;
  replaceBy: string;

  constructor(match: RegExp, replaceBy: string) {
    this.match = match;
    this.replaceBy = replaceBy;
  }
}

@Injection.injectableClass("EEWidget.DocumentCentre.QuerySuggestService")
export default class QuerySuggestService {

  @Injection.injectableProperty("EEWidget.DocumentCentre.QuerySuggestService", EECore.Registrations.HTTP_CLIENT)
  private httpClient: EECore.HttpClient;

  @Injection.injectableProperty("EEWidget.DocumentCentre.QuerySuggestService", EECore.Registrations.COOKIE)
  private cookie: EECore.Cookie;

  @Injection.injectableProperty("EEWidget.DocumentCentre.QuerySuggestService", EECore.Registrations.INTEGRATION_CONTEXT)
  private integrationContext: EECore.Integration.Context;

  constructor(httpClient: EECore.HttpClient, cookie: EECore.Cookie, integrationContext: EECore.Integration.Context) {
    this.httpClient = httpClient;
    this.cookie = cookie;
    this.integrationContext = integrationContext;
  }

  getSuggestions(keywords: string): EECore.Promise<QuerySuggestion[], string> {
    const coveoVisitorIdCookie = "coveo_visitorId";
    const requestData: Request = {
      count: 5,
      enableWordCompletion: false,
      isGuestUser: false,
      locale: this.integrationContext.language,
      q: keywords,
      searchHub: "Document Centre",
      pipeline: this.integrationContext.experience.cwSiteName,
      visitorId: this.cookie.getValue(coveoVisitorIdCookie)
    };

    return new EECore.Promise<QuerySuggestion[], string>((resolve, reject) => {
      const request = this.httpClient.sendRequest(`/coveo/rest/v2/querySuggest?siteName=${this.integrationContext.experience.cwSiteName}`, "POST", requestData, true);
      request.then((responseText) => {
        const response = JSON.parse(responseText) as Response;
        if (response && response.completions) {
          const suggestions: QuerySuggestion[] = [];

          response.completions.sort((a, b) => { return b.score - a.score; });
          for (let i = 0; i < response.completions.length; i++) {
            if (response.completions[i].executableConfidence >= 0.8) suggestions.push(this.buildSuggestion(response.completions[i]));
          }

          resolve(suggestions);
        }

        else {
          resolve([]);
        }
      });

      request.catch(reject as any);
    });
  }

  private buildSuggestion(completion: Completion): QuerySuggestion {
    const parseRules = [
      new CompletionParseRule(/\{/g, "<b>"),
      new CompletionParseRule(/\}/g, "</b>"),
      new CompletionParseRule(/\(/g, "<b><i>"),
      new CompletionParseRule(/\)/g, "</i></b>"),
      new CompletionParseRule(/\[/g, ""),
      new CompletionParseRule(/\]/g, "")
    ];

    let suggestionContent = completion.highlighted;
    for (let i = 0; i < parseRules.length; i++)
      suggestionContent = suggestionContent.replace(parseRules[i].match, parseRules[i].replaceBy);

    return {
      content: suggestionContent,
      searchExpression: completion.expression
    };
  }
}